/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import type { CatalogDashboard } from "@app/api/trpc/routers/catalog";
import { shortDate } from "./format";

type Props = { unsold: CatalogDashboard["gaps"]["unsold"]; days: number };

// Available products that didn't sell in the period, longest on the menu first.
export const SlowMovers = defineComponent<Props>({
  name: "SlowMovers",
  props: ["unsold", "days"],
  setup(props) {
    const { t } = useLocalization();

    return () => {
      if (props.unsold.count === 0) {
        return <p class="text-sm text-base-content/50">{t("catalog.overview.no_slow_movers")}</p>;
      }
      return (
        <div>
          <ul class="divide-y divide-base-200">
            {props.unsold.items.map((i) => (
              <li key={i.id} class="flex items-center justify-between gap-2 py-2 text-sm">
                <span class="truncate text-accent">{i.name}</span>
                <span class="whitespace-nowrap text-xs text-base-content/50">
                  {i.last_sold_at
                    ? t("catalog.overview.last_sold").replace("{date}", shortDate(i.last_sold_at))
                    : t("catalog.overview.never_sold")}
                </span>
              </li>
            ))}
          </ul>
          {props.unsold.count > props.unsold.items.length && (
            <p class="pt-2 text-xs text-base-content/40">
              {t("catalog.overview.and_more").replace("{count}", String(props.unsold.count - props.unsold.items.length))}
            </p>
          )}
        </div>
      );
    };
  },
});
